import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class ExternalCompanyService {

    constructor(private http: HttpClient) {}

    all(req){
        req.activeSort = req.activeSort || 'id';
        req.sortDirection = req.sortDirection || 'asc';
        req.page = req.page || 1; //default first page
        req.perPage = req.perPage || 5; //default no limit (por qué tenía -1?)
        req.filter = req.filter || '';
        req.trash = req.trash || '';

        let requestUrl = environment.apiUrl + 'external-company/all';
        requestUrl += "?page=" + req.page + "&perPage=" + req.perPage + "&activeSort=" + req.activeSort + "&sortDirection=" + req.sortDirection + "&filter=" + req.filter + "&trash=" + req.trash;

        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    add(branch){
        let requestUrl = environment.apiUrl + 'external-company/store';

        return this.http.post(requestUrl, branch).map( (res: any) => {
            return res;
        });
    }

    edit(branch){
        let requestUrl = environment.apiUrl + 'external-company/update/' + branch.id;
        return this.http.put(requestUrl, branch).map( (res: any) => {
            return res;
        });
    }

    get(id){
        let requestUrl = environment.apiUrl + 'external-company/get/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            // console.log('external company service: ' + JSON.stringify(res));
            return res;
        });
    }

    restore(id){
        let requestUrl = environment.apiUrl + 'external-company/restore/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    delete(id, forceDelete){
        let requestUrl = environment.apiUrl + 'external-company/delete/' + id;
        if(forceDelete){
            requestUrl += '?forceDelete=1';
        }
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/external.company.service.ts